import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout/Layout';
import About from './sections/About';
import Background from './sections/Background';
import Expertise from './sections/Expertise';
import Projects from './sections/Projects';
import Experience from './sections/Experience';
import LoadingAnimation from './components/LoadingAnimation';
import { Analytics } from "@vercel/analytics/react";


function App() {
  return (
    <>
      <LoadingAnimation />
      <Router>
        <Routes>
          <Route path="*" element={
            <Layout>
              <AnimatePresence mode="wait">
                <main className="main-content">
                  <About />
                  <Expertise />
                  <Projects />
                  <Experience />
                  <Background />
                </main>
              </AnimatePresence>
            </Layout>
          } />
        </Routes>
      </Router>
      <Analytics />
    </>
  );
}

export default App; 